'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StudentsFeiseannaController = function () {
  function StudentsFeiseannaController($state) {
    _classCallCheck(this, StudentsFeiseannaController);

    this._ = { $state: $state };

    this.f.showAll = false;
    this.shortlistedNum = 2;
  }

  _createClass(StudentsFeiseannaController, [{
    key: 'details',
    value: function details(feis, school) {
      this._.$state.go('feiseanna.one.registrations-for-school', { id: feis.id, sid: school.id, loggedinAccountId: this.user.id });
    }
  }, {
    key: 'shortlistedMessage',
    value: function shortlistedMessage(school) {
      return !school.showAll ? 'You are seeing ' + this.shortlistedNum + ' of ' + school.feiseanna.length + ' results' : 'You are seeing all ' + school.feiseanna.length + ' results';
    }
  }]);

  return StudentsFeiseannaController;
}();

exports.default = angular.module('ifeis.dashboard-student-feiseanna', ['ui.router']).directive('fStudentFeiseanna', function () {
  return {
    bindToController: true,
    controller: 'StudentsFeiseannaController',
    controllerAs: 'school',
    replace: true,
    scope: {
      f: '=feiseanna',
      user: '=user'
    },
    template: require('./tpl.html')
  };
}).controller('StudentsFeiseannaController', StudentsFeiseannaController);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/teacher-feiseanna/index.js
// module id = 529
// module chunks = 0